var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgWind = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99199 1.82503C8.18558 1.63029 8.42428 1.4864 8.68689 1.40614C8.94949 1.32589 9.22785 1.31176 9.49722 1.36502C9.7666 1.41827 10.0186 1.53726 10.231 1.7114C10.4433 1.88554 10.6093 2.10943 10.7142 2.36319C10.8191 2.61694 10.8597 2.89269 10.8324 3.16591C10.8051 3.43914 10.7106 3.70138 10.5575 3.92933C10.4044 4.15727 10.1974 4.34386 9.95479 4.4725C9.7122 4.60114 9.44158 4.66785 9.16699 4.66669H1.66699M10.492 14.175C10.6856 14.3698 10.9243 14.5137 11.1869 14.5939C11.4495 14.6742 11.7278 14.6883 11.9972 14.635C12.2666 14.5818 12.5186 14.4628 12.731 14.2887C12.9433 14.1145 13.1093 13.8906 13.2142 13.6369C13.3191 13.3831 13.3597 13.1074 13.3324 12.8341C13.3051 12.5609 13.2106 12.2987 13.0575 12.0707C12.9044 11.8428 12.6974 11.6562 12.4548 11.5276C12.2122 11.3989 11.9416 11.3322 11.667 11.3334H1.66699M14.7753 4.44169C15.0177 4.19993 15.3159 4.02162 15.6436 3.92254C15.9713 3.82345 16.3183 3.80664 16.6541 3.8736C16.9898 3.94055 17.3038 4.08921 17.5684 4.30642C17.833 4.52363 18.04 4.80269 18.1711 5.11894C18.3022 5.43518 18.3534 5.77885 18.32 6.11956C18.2867 6.46027 18.1699 6.78752 17.98 7.07236C17.7901 7.3572 17.5329 7.59085 17.2313 7.75265C16.9296 7.91445 16.5927 7.99941 16.2503 8.00003H1.66699",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWind, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/wind.b03089ef.svg";
export { ForwardRef as ReactComponent };